import React from 'react';
import { ResponsiveContainer, Pie, PieChart, Tooltip } from 'recharts';
import IntlMessages from 'util/IntlMessages';
const data = [
    {
        "name": "Budget",
        "value": 45
      },
      {
        "name": <IntlMessages id="Total"/>,
        "value": 55
      },
];


const Diagram = ({ width }) => {
    return (
        <div className="d-flex justify-content-start">
            <ResponsiveContainer width="97%" height={360}>
                <PieChart
                    width={730} 
                    height={250}
                >
                    <Tooltip cursor={{ stroke: '#0c969c', strokeWidth: 1, fill: "#0c969c" }} />
                    <Pie data={data} dataKey="value" nameKey="name" cx="52%" cy="40%" innerRadius={60} outerRadius={100} fill="#075a5f" />
                </PieChart>
            </ResponsiveContainer >
        </div >
    );
};

export default Diagram;